import { Injector } from "@angular/core";
import { WorkplaceActionHandlerBase } from "../../../../../../components/common/grid-base/actions/workplace-action-handler-base";
import { WorkplaceBase } from "../../../../../../components/common/workplace-base/workplace-base";

/**
 * Creates a template
 */
export class CreateTemplateWorkplaceActionHandler extends WorkplaceActionHandlerBase {
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   */
  constructor(injector: Injector, workplace: WorkplaceBase) {
    super(injector, workplace, 'buttonTemplate');
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle( _payload: any): void {
    this.workplace.main.createTemplate();
  }
}
